import React from "react"
import _ from "lodash"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import platform from "platform"

import "./Video.scss"

const Video = ({ data }) => {
  const url = data.url || data.downloadUrl || _.get(data, "attachments[0].url")
  if (url) {
    return (
      <div className={`message-bubble video ${platform.os.family === "Android" || platform.os.family === "Windows Phone" ? "android" : ""}`}>
        <video src={url} controls>
        </video>
      </div>
    )
  }
  return (
    <div className="message-bubble video placeholder">
      <FontAwesomeIcon
        className="icon"
        icon="video"
      />
      <span>Video cannot be loaded</span>
    </div>
  )
}

export default Video
